export default __webpack_public_path__ + "static/media/videos1.7015f6dc.jpg";